export default class RegroupementSitesService {
	static $inject = ['$http'];

	constructor($http) {
		this.$http = $http;
	}

	async getSocietesCom() {
		let url = `${__configuration.apiUrl}/massia/societes-commerciales`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getSitesCommerciauxBySociete(idSociete) {
		const GENRE_SITE_UTILISATEUR = 1;
		const res = await this.$http.get(`${__configuration.apiUrl}/massia/sites-commerciaux/header/${idSociete}/genre/${GENRE_SITE_UTILISATEUR}`);
		return res.data;
	}

	async getRegroupementSitesBySociete(idSociete) {
		const res = await this.$http.get(`${__configuration.apiUrl}/massia/regroupement-sites/societe/${idSociete}`);
		return res.data;
	}

	async updateRegroupementSites(idSociete, regroupementSites) {
		try {
			const res = await this.$http.put(`${__configuration.apiUrl}/massia/regroupement-sites/societe/${idSociete}`, regroupementSites);
			return res.data;
		} catch (error) {
			console.error('🔥: RegroupementSitesService -> updateRegroupementSites -> error', error);
		}
	}
}
